import React from 'react';
import { observer } from 'mobx-react';
import CheckoutLinkListService from '../services/CheckoutLinkListService';
import CheckoutLinkListFilter from './CheckoutLinkListFilter';

const CheckoutLinkListFilterContainer = () => (
  <CheckoutLinkListFilter
    value={CheckoutLinkListService.filter}
    onChange={CheckoutLinkListService.handleFilterChange}
  />
);

export default observer(CheckoutLinkListFilterContainer);
